function initializeSortOrder() {
    // Get current sort value from URL
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get("sort_by");

    // If there's a price sort parameter in URL, apply the sort
    if (
        currentSort === "price-ascending" ||
        currentSort === "price-descending"
    ) {
        processPriceSort(currentSort);

        // Update dropdown and radio buttons to match URL state
        const sort_by = document.getElementById("sort_by");
        if (sort_by) {
            sort_by.value = currentSort;
        }

        const radioInputs = document.querySelectorAll(
            'input[type="radio"][name="sort_by"]'
        );
        if (radioInputs) {
            Array.from(radioInputs).forEach(function (input) {
                input.checked = input.value === currentSort;
            });
        }
    }
}

const CollectionSortObserver = {
    isProcessing: false,

    init() {
        // Watch for DOM changes in the collection list
        const productList = document.querySelector(".l4cl");
        if (!productList) return;

        // Create mutation observer
        this.observer = new MutationObserver((mutations) => {
            if (!this.isProcessing) {
                this.debounceHandleDOMChanges(mutations);
            }
        });

        // Start observing
        this.observer.observe(productList, {
            childList: true,
        });

        // Initial check for sort state
        this.checkAndApplySort();
    },

    debounceHandleDOMChanges: function (mutations) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            this.handleDOMChanges(mutations);
        }, 100);
    },

    handleDOMChanges(mutations) {
        // Check if changes were caused by load more
        const hasNewProducts = mutations.some(
            (mutation) =>
                mutation.addedNodes.length > 0 &&
                Array.from(mutation.addedNodes).some(
                    (node) =>
                        node.nodeType === 1 &&
                        (node.classList.contains("product-card") ||
                            node.querySelector(".product-card"))
                )
        );

        if (hasNewProducts) {
            // Disconnect observer temporarily
            this.observer.disconnect();
            this.isProcessing = true;

            // Apply sort
            this.checkAndApplySort();

            // Reconnect observer
            const productList = document.querySelector(".l4cl");
            if (productList) {
                this.observer.observe(productList, {
                    childList: true,
                });
            }

            this.isProcessing = false;
        }
    },

    checkAndApplySort() {
        const urlParams = new URLSearchParams(window.location.search);
        const currentSort = urlParams.get("sort_by");

        if (
            currentSort === "price-ascending" ||
            currentSort === "price-descending"
        ) {
            processPriceSort(currentSort, false);
        }
    },

    destroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
        clearTimeout(this.debounceTimer);
    },
};

// Initialize only on collection pages
if (window.location.pathname.includes("/collections/")) {
    // Wait for a short delay to ensure other scripts are loaded
    setTimeout(() => {
        CollectionSortObserver.init();
    }, 100);
}

// Re-initialize when collection is updated
window.addEventListener("collectionUpdated", () => {
    CollectionSortObserver.destroy();
    CollectionSortObserver.init();
});

function processPriceSort(sortDirection, updateUrl = true) {
    const productList = document.querySelector(".l4cl");
    if (!productList) return;

    productList.classList.add("processing");

    // Get all product items
    const products = Array.from(productList.children);

    // Extract price and create sortable array
    const productsWithPrices = products.map((product) => {
        let price = Infinity;
        const priceElement = product.querySelector(
            ".s1pr span:not(.old-price):not(.price-varies)"
        );

        if (priceElement) {
            price =
                parseFloat(
                    priceElement.textContent.replace(/[^0-9.-]+/g, "")
                ) || Infinity;
        }

        return {
            element: product,
            price: price,
        };
    });

    // Sort the array
    productsWithPrices.sort((a, b) => {
        if (sortDirection === "price-ascending") {
            return a.price - b.price;
        } else if (sortDirection === "price-descending") {
            return b.price - a.price;
        }
        return 0;
    });

    // Move elements directly to maintain states
    const fragment = document.createDocumentFragment();
    productsWithPrices.forEach((item) => {
        fragment.appendChild(item.element);
    });

    while (productList.firstChild) {
        productList.removeChild(productList.firstChild);
    }
    productList.appendChild(fragment);
    productList.classList.remove("processing");

    if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set("sort_by", sortDirection);
        window.history.pushState({ path: url.toString() }, "", url.toString());
    }
}

// Listen for collection updates
document.addEventListener("DOMContentLoaded", () => {
    // Check for initial sort
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get("sort_by");

    if (
        currentSort === "price-ascending" ||
        currentSort === "price-descending"
    ) {
        processPriceSort(currentSort, false);
    }

    // Override load more button click handler
    const originalLoadMore = window.collectionLoadMoreAsync;
    window.collectionLoadMoreAsync = function () {
        originalLoadMore();

        // Add event listener to load more button
        const loadMoreButtons = document.querySelectorAll(
            "#load-more-button[data-next], #load-more-button[data-prev]"
        );
        loadMoreButtons.forEach((button) => {
            const existingHandler = button.onclick;
            button.onclick = async function (e) {
                if (existingHandler) {
                    existingHandler.call(this, e);
                }

                // Wait for new products to be loaded
                setTimeout(() => {
                    const currentSort = new URLSearchParams(
                        window.location.search
                    ).get("sort_by");
                    if (
                        currentSort === "price-ascending" ||
                        currentSort === "price-descending"
                    ) {
                        processPriceSort(currentSort, false);
                    }
                }, 500);
            };
        });
    };
});
